export default [
  {
    path: '/TTincident',
    name: 'TTincident',
    component: () => import('../../components/TTincident.vue'),
    // 将 TikTok 像素激活工具归入首页工具导航。
    meta: {
      title: 'TT 像素激活工具',
      category: 'pixelTools',
    },
  },
  {
    path: '/FBincident',
    name: 'FBincident',
    component: () => import('../../components/FBincident.vue'),
    // 将 Facebook 像素激活工具归入首页工具导航。
    meta: {
      title: 'FB 像素激活工具',
      category: 'pixelTools',
    },
  },
  {
    // BIGO 像素激活工具与 TT、FB 共用首页工具分类。
    path: '/BIGOincident',
    name: 'BIGOincident',
    component: () => import('../../components/BIGOincident.vue'),
    meta: {
      title: 'BIGO 像素激活工具',
      category: 'pixelTools',
    },
  },
  {
    path: '*',
    name: 'NotFound',
    component: () => import('../../components/404.vue'),
  },
];
